// extracted by mini-css-extract-plugin
export default {"notification_card":"notification_notification_card__M-PzJ","message":"notification_message__r6v4N"};